import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../config/apiConfig";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [popularRoutes, setPopularRoutes] = useState([]);
  const [popularCities, setPopularCities] = useState([]);
  const [footerRoutes, setFooterRoutes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const promises = [
          axios
            .get(`${API_URL}/popular-routes`)
            .catch(() => ({ data: [] })),
          axios
            .get(`${API_URL}/popular-cities`)
            .catch(() => ({ data: [] })),
          axios
            .get(`${API_URL}/footer-routes`)
            .catch(() => ({ data: [] })),
        ];

        const [routesRes, citiesRes, footerRoutesRes] =
          await Promise.all(promises);

        setPopularRoutes(routesRes.data || []);
        setPopularCities(citiesRes.data || []);
        setFooterRoutes(footerRoutesRes.data || []);
      } catch (error) {
        console.error("Footer data error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <footer className="footer-section" style={{ color: '#000000B2' }}>
      <style>{`
        .footer-section {
          background-color: #EAF0FC;
          width: 100%;
          color: #000000B2;
        }

        .footer-skyline {
          width: 100%;
          height: 110px;
          background-color: #ffffffff;
          background-image: url('/icons/Vector.svg');
          background-size: contain;
          background-position: center bottom;
          background-repeat: repeat-x;
        }

        @media (max-width: 768px) {
          .footer-skyline {
            height: 80px;
          }
        }

        .footer-content {
          padding: 20px 0 20px 0;
        }

        .footer-divider {
          border-top: 1px solid #bfc8d8;
          margin: 20px 0;
        }

        .footer-title {
          font-weight: 700;
          border-bottom: 2px solid #1f2937;
          display: inline-block;
          padding-bottom: 4px;
          margin-bottom: 16px;
          color: #000000B2;
        }

        .app-badge {
          width: 150px;
          transition: opacity 0.3s ease;
        }

        .app-badge:hover {
          opacity: 0.85;
        }

        .footer-section a {
          color: #000000B2;
        }

        .footer-section a:hover {
          color: #2563eb;
        }

        .footer-section p,
        .footer-section li,
        .footer-section span {
          color: #000000B2;
        }
      `}</style>

      {/* Skyline */}
      <div className="footer-skyline" />

      {/* Content */}
      <div className="footer-content">
        <div className="max-w-[1180px] mx-auto px-4 sm:px-6 md:px-8 lg:px-6">

          {/* Top Section */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

            {/* Company Info */}
            <div>
              <h3 className="footer-title text-lg">CabZigo</h3>
              <p className="text-sm mb-4">
                Book outstation cabs at the lowest prices with clean cars,
                experienced drivers and transparent billing.
              </p>
              <div className="flex space-x-3 text-lg">
                <a href="https://facebook.com" target="_blank" rel="noreferrer">
                  <FaFacebook className="hover:text-blue-600" />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noreferrer">
                  <FaTwitter className="hover:text-blue-400" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noreferrer">
                  <FaInstagram className="hover:text-pink-600" />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                  <FaLinkedin className="hover:text-blue-700" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="footer-title text-lg">Quick Links</h3>

              <ul className="text-sm space-y-2 list-disc list-inside text-gray-700">
                <li>
                  <Link to="/about" className="hover:text-blue-600">
                    About Us
                  </Link>
                </li>
              
                <li>
                  <Link to="/media" className="hover:text-blue-600">
                    Media
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="hover:text-blue-600">
                    Contact
                  </Link>
                </li>
                <li>
                  <Link to="/login" className="hover:text-blue-600">
                    Login
                  </Link>
                </li>
                <li>
                  <Link to="/register" className="hover:text-blue-600">
                    Register
                  </Link>
                </li>
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h3 className="footer-title text-lg">Contact Us</h3>
              <ul className="text-sm space-y-3">
                <li className="flex items-start">
                  <FaMapMarkerAlt className="mr-2 mt-1 text-black" />
                  Rajkot, Gujarat
                </li>
                <li className="flex items-start">
                  <FaPhoneAlt className="mr-2 mt-1 text-black" />
                  +91 23456 78900
                </li>
                <li className="flex items-start">
                  <FaEnvelope className="mr-2 mt-1 text-black" />
                  cabzigo@gmail.com
                </li>
              </ul>
            </div>

            {/* App Download */}
           <div>
  <h3 className="footer-title text-lg">Download Mobile App</h3>

  <div className="space-y-3">
    <a href="#" target="_blank" rel="noreferrer">
      <img
        src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
        alt="Google Play"
        className="h-16 w-auto"
      />
    </a>

    <a href="#" target="_blank" rel="noreferrer">
      <img
        src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
        alt="Download on the App Store"
        className="h-12 w-auto ml-3"
      />
    </a>
  </div>
</div>
          </div>

          <div className="footer-divider" />

          {/* Popular Cities & Routes */}
          {!loading && (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
              {popularCities.length > 0 && (
                <div>
                  <h3 className="footer-title text-base">
                    Popular Cities
                  </h3>
                  <div className="text-sm">
                    {popularCities.slice(0, 5).map((city, index, array) => (
                      <span key={city._id}>
                        <Link
                          to={`/search?city=${city.name}`}
                          className="hover:text-blue-600"
                        >
                          {city.name}
                        </Link>
                        {index < array.length - 1 && (
                          <span className="mx-2">|</span>
                        )}
                      </span>
                    ))}
                  </div>
                </div>
              )}

              {popularRoutes.length > 0 && (
                <div>
                  <h3 className="footer-title text-base">
                    Fixed Routes
                  </h3>
                  <ul className="text-sm space-y-2">
                    {popularRoutes.slice(0, 6).map((route, index) => (
                      <li key={route._id || index}>
                        <Link
                          to={`/cabs?from=${route.from}&to=${route.to}`}
                          className="hover:text-blue-600"
                        >
                          {route.from} → {route.to}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          )}
          {/* Cab From Section */}
          {!loading && footerRoutes.length > 0 && (
            <>
              <div className="footer-divider" />

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {footerRoutes.slice(0, 4).map((category) => (
                  <div key={category._id}>
                    <h3 className="footer-title text-base">
                      {category.category}
                    </h3>

                    <ul className="text-sm space-y-2">
                      {category.routes.slice(0, 3).map((route, index) => (
                        <li key={index}>
                          <Link
                            to={`/cabs?from=${encodeURIComponent(
                              route.from
                            )}&to=${encodeURIComponent(route.to)}`}
                            className="hover:text-blue-600 transition-colors"
                          >
                            {route.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </>
          )}

          <div className="footer-divider" />

          {/* Bottom */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 pt-6">
            <h2 className="font-semibold text-gray-800 text-sm text-center md:text-left">
              {currentYear} CabZigo. All rights reserved.
            </h2>

            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <Link
                to="/terms"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors"
              >
                Terms & Conditions
              </Link>

              <Link
                to="/privacy"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors"
              >
                Privacy Policy
              </Link>

              <Link
                to="/refund"
                className="font-semibold text-gray-800 hover:text-blue-600 transition-colors"
              >
                Refund Policy
              </Link>
            </div>
            
          </div>
          

        </div>
      </div>
    </footer>
  );
};

export default Footer;
